import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Configure from "@/pages/Configure";
import Schedule from "@/pages/Schedule";
import Contact from "@/pages/Contact";
import Confirmation from "@/pages/Confirmation";
import Lookup from "@/pages/Lookup";
import Admin from "@/pages/Admin";
import Share from "@/pages/Share";
import Care from "@/pages/Care";
import PrintDay from "@/pages/PrintDay";
import PrintRemovals from "@/pages/PrintRemovals";
import { BookingProvider } from "@/context/BookingContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BookingProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/configure" element={<Configure />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/confirmation" element={<Confirmation />} />
            <Route path="/lookup" element={<Lookup />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/share/:reference" element={<Share />} />
            <Route path="/care" element={<Care />} />
            <Route path="/admin/print" element={<PrintDay />} />
            <Route path="/admin/print-removals" element={<PrintRemovals />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-right"
          offset={88}
          richColors
          toastOptions={{ style: { fontFamily: "'Plus Jakarta Sans', sans-serif" } }}
        />
      </BookingProvider>
    </div>
  );
}

export default App;
